export default "__VITE_ASSET__AZjBoF6x__"